import { GET_EMPLOYEE_DEPARTMENTS, GET_EMPLOYEE_DESIGNATIONS, GET_EMPLOYEES, GET_TEACHERS, GET_VENDOR_ACCOUNTS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type TeacherFilterType = {
  employeeId: number;
  departmentId: number;
  designationId: number;
  isArchived: boolean;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const teacherFilterInitialValues: TeacherFilterType = {
  employeeId: 0,
  departmentId: 0,
  designationId: 0,
  isArchived: false,
  created_at: [null, null],
  updated_at: [null, null],
};

export const teacherFilterValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const teacherFilterProperties = [


  {
    id: "departmentId",
    type: "single-select-search",
    label: "Department",
    // list: "employee_departments_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_EMPLOYEE_DEPARTMENTS,
    gqlKey: "getEmployeeDepartments",
    dataKey: "employeeDepartments",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "designationId",
    type: "single-select-search",
    label: "Designation",
    // list: "employee_designations_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_EMPLOYEE_DESIGNATIONS,
    gqlKey: "getEmployeeDesignations",
    dataKey: "employeeDesignations",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },

  {
    id: "employeeId",
    type: "single-select-search",
    label: "Teachers",
    keyValue: {
      label: "employeeDropdownLabel",
      value: "employeeDropdownValue"
    },
    query: GET_TEACHERS,
    gqlKey: "getTeachers",
    dataKey: "teachers",
    dependentOn: ["departmentId", "designationId"],
    searchFieldKey: "searchName",
    strictDependency: false,
    formatDependentPayload: ([departmentId, designationId]: any) => {
      return {
        ...(departmentId && { departmentId: Number(departmentId) }),
        ...(designationId && { designationId: Number(designationId) })
      };
    },
    formatData: (teachers: any[]) => {
      if (!teachers) return [];
      return teachers.map((teacher: any) => ({
        ...teacher,
        employeeDropdownLabel: `${teacher?.employee?.employeeId || ""} ${teacher?.employee?.firstName || ""} ${teacher?.employee?.lastName || ""}`.trim(),
        employeeDropdownValue: teacher?.id
      }));
    },
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },

  {
    id: "isArchived",
    type: "normal-select",
    label: "Is Archived",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: true,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
